<template>
    <div id="app">
        <router-view />
        <pc-footer v-show="!hidden"></pc-footer>
    </div>
</template>

<script>
import Footer from './layout/footer'

export default {
  name: 'App',
  data() {
			return {
        hidden:false
			}
		},
  components: {
    'pc-footer': Footer
  },
 	watch: {
			'$route'() {
        // this.$store.dispatch('SetTitle', this.$route.meta.title)
        if(this.$route.meta&&this.$route.meta.hidden){
            this.hidden=true
        }else{
          this.hidden=false
        }
			}
		},
}
</script>

<style>
body,
html {
    padding: 0;
    margin: 0;
}
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    background-color: #f4f4f4;
}
</style>



// WEBPACK FOOTER //
// src/App.vue